import moment from "moment"
export const filterMixins = {
    filters: {
        truncate: function(string, value) {
            if (string.length <= value) {
                return string;
            }
            return string.substring(0, value) + '...';
        },
        format_date(value) {
            if (value) {
                return moment.unix(String(value)).format('YYYY-MM-DD HH:MM:SS')
            }
        }
    }
}